<template>
  <div class="subscriptions-table clients-table">
    <template v-if="!isLoading">
      <table-lite
        :is-loading="isLoading"
        :columns="columns"
        :rows="rows"
        :total="totalRecordCount"
        :is-static-mode="true"
        :sortable="sortable"
        :pageOptions="[
          { value: 50, text: 50 },
          { value: 75, text: 75 },
          { value: 100, text: 100 },
        ]"
        @do-search="$emit('doSearch')"
        @row-clicked="(row) => $emit('client-clicked', row)"
        @is-finished="tableLoadingFinish"
        @return-checked-rows="checkRow"
        v-show="!isLoading"
        :messages="messages"
        :class="totalRecordCount > 10 ? 'has-pagination' : ''"
      >
      </table-lite>
    </template>
    <clients-table-loading v-else />
  </div>
</template>

<script>
import TableLite from "vue3-table-lite";
import ClientsTableLoading from "./ClientsTableLoading.vue";

export default {
  components: {
    TableLite,
    ClientsTableLoading,
  },
  props: {
    clients: Array,
    dataLoading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isLoading: true,
      columns: [
        {
          label: "اسم الشركة",
          field: "CompanyName",
          sortable: true,
          width: "auto",
        },
        {
          label: "الإسم",
          field: "Name",
          sortable: true,
          width: "auto",
        },
        {
          label: "البريد الالكتروني",
          field: "Email",
          sortable: true,
          width: "auto",
        },
        {
          label: "الجوال",
          field: "Phone",
          sortable: true,
          width: "15%",
        },
        {
          label: "الرصيد",
          field: "Balance",
          sortable: true,
          width: "7%",
        },
      ],
      rows: [],
      totalRecordCount: 0,
      sortable: {
        order: "CompanyName",
        sort: "asc",
      },
      messages: {
        pagingInfo: "عرض {0}-{1} من {2}",
        pageSizeChangeLabel: "عدد الصفوف:",
        gotoPageLabel: "الذهاب للصفحة:",
        noDataAvailable: "لا يوجد اي بيانات",
      },
    };
  },
  watch: {
    dataLoading(newVal) {
      this.isLoading = newVal;
    },
    clients(newVal) {
      this.setRows(newVal);
    },
  },
  mounted() {
    this.setRows(this.clients);
  },
  methods: {
    setRows(rows) {
      this.rows = rows;
      this.totalRecordCount = rows.length;
      this.isLoading = false;
    },
    checkRow(row) {
      // do action on checking row
    },

    tableLoadingFinish(elements) {
      this.isLoading = false;
    },
  },
};
</script>

<style lang="scss">
.clients-table .vtl-tbody-td span {
  max-width: 100%;
}
.clients-table .vtl-tbody-td:last-child {
  width: 7%;
}
.clients-table .vtl-tbody-td:nth-last-child(2) {
  width: 15%;
}
</style>